import { CompanySideBarTreeViewService } from './../../company-view/services/company-side-bar-tree-view.service';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { __rest } from 'tslib';
import { EmployeeAttribute } from '../entities/employee-attribute';
import { StaffCount } from '../entities/staff-count';
import { StaffDetail } from '../entities/staff-detail';
import { StaffDetailQuery } from '../entities/staff-detatil-query';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { StaffCountService } from '../services/staff-count.service';
import * as moment from 'moment'
import Utils from 'app/Utils';

@Component({
    selector: 'app-staff-count-view',
    templateUrl: './staff-count-view.component.html',
    styleUrls: ['./staff-count-view.component.scss'],
    standalone: false
})
export class StaffCountViewComponent implements OnInit {
  empresaId: number;
  attributeList: EmployeeAttribute[];
  staffCountList: StaffCount[];
  tabIndex: number;
  selectedCompany: string;
  intialCellValue: number;
  selectedAttributeData: number;
  permissionList: any;
  tipo: string;
  isDisabledTotalizar: boolean;
  isCompanySelected:boolean;
  isCompanyActive: boolean = true;
  private selectedDate: moment.Moment;
  public hasPermi856 = false;


  constructor(private _companySideBarTreeViewService: CompanySideBarTreeViewService,public router: Router, private _staffCountService: StaffCountService, public empresaTreeViewService: EmpresaTreeViewService, public dialog: MatDialog, private pageLoaderService: PageLoaderService,
      private _sharedService: SharedService) {
    this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
      // if (_res > 0) {
      //   this.empresaId = _res;
      //   const companyName = localStorage.getItem('SelectedCompanyName');
      //   if (companyName) {
      //     this.selectedCompany = String(companyName);
      //   }
      //   this._staffCountService.showDetailPanel = false;
      //   this.getAttributeListByEmpresaId(this.empresaId); // DOCÈNCIA
      //   this.getStaffCountListByEmpresaId(this.empresaId);
      // }        
    })
   
  }
  refreshCount(empresaObj: any) {
    this.isCompanySelected=true;
    let empresa = empresaObj.empresa;
    let empresaid=empresaObj.empresaId
    if(empresaid==0)
    {
      
      empresaid=1;
      empresa="IT"
    }
    if (empresaid > 0) {
      this.empresaId = empresaid;
      const companyName = empresa;
      if (companyName) {
        this.selectedCompany = String(companyName);
      }
      this._staffCountService.showDetailPanel = false;
      this.getAttributeListByEmpresaId(this.empresaId); // DOCÈNCIA
      this.getStaffCountListByEmpresaId(this.empresaId);
      this.getCompanyActive(this.empresaId);
    }
  }

  ngOnInit(): void {
    this.permissionList = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
    this.isCompanySelected=false;
    this.attributeList = new Array<EmployeeAttribute>();
    this.empresaId = JSON.parse(localStorage.getItem('Empresa'));
    const companyName = localStorage.getItem('SelectedCompanyName');
    if (companyName) {
      this.selectedCompany = String(companyName);
    }
    this.getAttributeListByEmpresaId(this.empresaId); // DOCÈNCIA
    this.getStaffCountListByEmpresaId(this.empresaId);
    this.getCompanyActive(this.empresaId);
    this.intialCellValue = 0;
    this.selectedAttributeData = 0;
    this.tabIndex = 0;
    this.tipo = 'E';
    this.isDisabledTotalizar = true;
    //Se añade para restringir la importación a perfiles que no deben importar plantillas/censos
    this._sharedService.setCurrentUserPermissions();
    this.hasPermi856 = this._sharedService.Permissions.HasPermisos856;
  }

  //#region staff count button section

  getCompanyList(): void {
    this.empresaTreeViewService.getEmpresaTreeView().subscribe((res: any) => {
      if (res.code === 0) {
        const empressaId = localStorage.getItem('Empresa');
        const list = res.result.filter(x => x.parent == empressaId);
      } else if (res.code === 1) {
        return null;
      }
    });
  }

  /**
   * Determines whether recalcular totales on
   */
  onRecalcularTotales() {
    this.refreshesPlantillaTotalData();
  }

  /**
   * Refreshes plantilla total data
   */
  refreshesPlantillaTotalData(): void { 
    this.pageLoaderService.ShowPageLoader();
  
    if (!this.empresaId) {
      this.pageLoaderService.HidePageLoader();
      this._sharedService.ShowSnackBar("ID de empresa no válido", "error");
      return;
    }
  
    this._staffCountService.isActive(this.empresaId).subscribe((isActive: boolean) => {
      if (!isActive) {
        this.pageLoaderService.HidePageLoader();
        this._sharedService.ShowSnackBar("Empresa inactiva. Acción no disponible", "error");
        return;
      }
  
      this._staffCountService.refreshesPlantillaTotalData().subscribe(
        res => {
          this.pageLoaderService.HidePageLoader();
          this._sharedService.ShowSnackBar("Actualización de datos con éxito");
        },
        err => {
          this.pageLoaderService.HidePageLoader();
          console.error("Error al actualizar datos:", err);
          this._sharedService.ShowSnackBar("Error al actualizar los datos. Inténtelo de nuevo.", "error");
        }
      );
    });
  }

  /**
   * Determines whether este nivel on
   */
  onEsteNivel() {
    this.openConfirmDialogForEsteNivel();
  }

  /**
   * Opens confirm dialog for este nivel
   */
  openConfirmDialogForEsteNivel(): void {
    const message = `Se van a eliminar todas las plantillas de este atributo de esta empresa y todas las empresas de niveles inferiores excepto los del último nivel. Para cada nivel inferior, se cargarán los totales de los meses introducidos de los atributos que coincidan de las delegaciones del siguiente nivel. ¿Continuar?`;
    const dialogData = new ConfirmDialogModel(message, '');
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        this.getEmpresaListByEmpresaId(true);
      }
    });
  }

  /**
   * Determines whether todos los niveles inferiors on
   */
  onTodosLosNivelesInferiors() {
    this.openConfirmDialogForTodosLosNivelesInferiors();
  }

  /**
   * Opens confirm dialog for todos los niveles inferiors
   */
  openConfirmDialogForTodosLosNivelesInferiors(): void {
    const message = `Se van a eliminar todas las plantillas de este atributo y se cargarán los totales en los meses introducidos de los atributos que coincidan de las delegaciones de sólo el siguiente nivel. ¿Continuar?`;
    const dialogData = new ConfirmDialogModel(message, '');
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        this.getEmpresaListByEmpresaId(false);
      }
    });
  }

  /**
   * Gets empresa list by empresa id
   * @param isEsteNivel 
   */
  getEmpresaListByEmpresaId(isEsteNivel: boolean) {
    const empressaId = localStorage.getItem('Empresa');
    if (empressaId) {
      this._staffCountService.getEmpresaListByEmpresaId(empressaId).subscribe(res => {
        if (res.result && res.result != undefined) {
          const list = res.result;
          if (list.length > 0) {
            if (isEsteNivel) {
              // totalize selected company
              this.totalizeSelectedCompany(empressaId, this.tabIndex);
            } else {
              // totalize selected company and all its subcompanies
              this.totalizeSelectedCompanyAndSubCompanies(empressaId, this.tabIndex);
            }
          } else {
            this._sharedService.ShowSnackBar('Esta empresa no tiene niveles inferiores');
          }

        }
      }, err => {
        console.error(err);
      });
    }
  }

  /**
   * Totalizes selected company
   * @param empressaId 
   */
  totalizeSelectedCompany(empressaId: any, tabIndex: any) {
    if (empressaId) {
      this.pageLoaderService.ShowPageLoader();
      this._staffCountService.totalizeSelectedCompany(empressaId, tabIndex).subscribe(res => {
        if (res != undefined) {
          this._staffCountService.staffDetail.emit({ companyId: empressaId, year: this._staffCountService.selectedYear.toString(), month: '', attribute: '', tipo: this.tabIndex.toString() });
          this._staffCountService.showDetailPanel = false;
          this.pageLoaderService.HidePageLoader();
          this._sharedService.ShowSnackBar('Totalizar la función con éxito');
        }
      }, err => {
        console.error(err);
      });
    }
  }

  totalizeSelectedCompanyAndSubCompanies(empressaId: any, tabIndex: any) {
    if (empressaId) {
      this.pageLoaderService.ShowPageLoader();
      this._staffCountService.totalizeSelectedCompanySubCompanise(empressaId, tabIndex).subscribe(res => {
        if (res != undefined) {
          
          this._staffCountService.staffDetail.emit({ companyId: empressaId, year: this._staffCountService.selectedYear.toString(), month: '', attribute: '', tipo: this.tabIndex.toString() });
          this._staffCountService.showDetailPanel = false;
          this.pageLoaderService.HidePageLoader();
          this._sharedService.ShowSnackBar('Totalizar la función con éxito');
        }
      }, err => {
        console.error(err);
      });
    }
  }

  getAttributeListByEmpresaId(empresaId: any) {
    this._staffCountService.getAttributeListByEmpresaId(empresaId)
      .subscribe(res => {
        this.attributeList = res.result;
      }, err => {
        console.error(err);
      });
  }

  getStaffCountListByEmpresaId(empresaId: any) {
    this._staffCountService.getCompanyStaffCountByEmpresaId(empresaId)
      .subscribe(res => {
        this.staffCountList = res.result;
      }, err => {
        console.error(err);
      });
  }

  tabChange($event) {
    this.tabIndex = $event.index;
    this.tipo = this.tabIndex == 0 ? "E" : this.attributeList[this.tabIndex-1].attrNo.toString();
    this._staffCountService.showDetailPanel = false;
    this.isDisabledTotalizar = this.tabIndex == 0 ? true : false;
  }

  updateCell(cellValue, year, month) {
    if (cellValue) {
      this.updateCompanyStaffCount(this.empresaId, year, month, cellValue);
    } else {
      this.deleteCompanyStaffCount(this.empresaId, year, month);
    }
  }

  onEnterUpdateCell(cellValue, year, month) {
    if (cellValue) {
      this.updateCompanyStaffCount(this.empresaId, year, month, cellValue);
    }
    this._staffCountService.detailsSelected.emit({ companyId: this.empresaId.toString(), year: year, month: month, tipo: 'E' });
  }

  getIntialCellValue(cellValue, companyId, year, month, tipo) {
    this.intialCellValue = cellValue;
    this.selectedAttributeData = this.intialCellValue;
    this._staffCountService.detailsSelected.emit({ companyId: companyId, year: year, month: month, tipo: tipo });
  }

  mouseOutEvent(cellValue, companyId, year, month, tipo) {
    this._staffCountService.detailsSelected.emit({ companyId: companyId, year: year, month: month, tipo: tipo });
  }

  refreshGeneral(data) {
    this.getStaffCountListByEmpresaId(data.companyId);
  }

  refreshAttribute(data) {
    this._staffCountService.staffDetail.emit({ companyId: data.companyId, year: data.year, month: data.month, attribute: data.attribute, tipo: data.tipo });
  }

  updateCompanyStaffCount(companyId: any, year: string, month: string, staffCount: string): void {
    this._staffCountService.updateCompanyStaffCount(companyId, year, month, staffCount)
      .subscribe(res => {
        if (res.code === 0) {
          // Success
        } else {
          //Error
        }
      }, err => {
        console.error(err);
      });
  }

  deleteCompanyStaffCount(companyId: any, year: string, month: string): void {
    this._staffCountService.deleteCompanyStaffCount(companyId, year, month)
      .subscribe(res => {
        if (res.code == 0) {
          // Success
        } else {
          //Error
        }
      }, err => {
        console.error(err);
      });
  }
  //#endregion

   getCompanyActive(empresaId: any) {
    if (!empresaId) return;
  
    this._staffCountService.isActive(empresaId).subscribe((res: boolean) => {
      this.isCompanyActive = res;
    });
  }

}
